import React, {Component} from 'react';
import * as firebase from 'firebase';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import {Link} from 'react-router-dom'

export default class GetBootstrapTable extends Component {
  constructor() {
    super();
    this.state = {
      quiz: []
    }
    this.buttonFormatter = this.buttonFormatter.bind(this);
    this.gotData = this.gotData.bind(this);
    this.errData = this.errData.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0,0)
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        var userId = firebase.auth().currentUser.uid;
        const quizRef = firebase.database().ref('users/').child(userId).child('Answers');
        const getNameRef = firebase.database().ref('users/').child(userId).child('UserProfile');
        getNameRef.on('value', snap => {
          this.setState({
            displayName: snap.val().displayName
          })
        })
        quizRef.on('value', snap => {
          var exists = (snap.val() !== null)
          if(exists) {
            quizRef.on('value', this.gotData, this.errData)
          }
         }
        )
      }
    })
  }

  gotData(data) {
   let newProducts = []
   const userdata = data.val();
   const keys = Object.keys(userdata);
   for (let i = 0; i < keys.length; i++) {
    const k = keys[i];
    newProducts.push({
      name: userdata[k].name,
      ans: userdata[k].ans,
      createDate: userdata[k].createDate,
      createTime: userdata[k].createTime,
      Reviews: userdata[k].Reviews,
      id: userdata[k].id
    });
  }
  this.setState({
    quiz: newProducts.reverse()
   })
  }
  errData(err) {
   console.log(err);
  }
  buttonFormatter(id, quiz) {
    const location = {
      pathname: `/Answer/${quiz.id}`,
      state: { fromDashboard: true }
    }
    return  <Link to={location}>查看結果</Link>
  }
  render() {
    return(
      <div>
      <BootstrapTable
       ref='table'
       data={ this.state.quiz }
       pagination={ true }
       search={ true }
       bodyContainerClass='table-responsive'
       trClassName={ this.trClassFormat }>
       <TableHeaderColumn dataField='name' isKey={true} dataSort={ true }>名稱</TableHeaderColumn>
       <TableHeaderColumn dataField='ans' dataSort={ true }>得分</TableHeaderColumn>
       <TableHeaderColumn dataField='createDate' dataSort={ true }>日期</TableHeaderColumn>
       <TableHeaderColumn dataField='createTime' dataSort={ true }>時間</TableHeaderColumn>
       <TableHeaderColumn dataSort={ true } dataFormat={this.buttonFormatter}>測量結果</TableHeaderColumn>
      </BootstrapTable>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/getBootstrapTable.js